module.exports = __webpack_public_path__ + "static/jergal-symbol-SCAG-136ca66ce1512e470104e9e2f78aa8bf.png";